import React from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'
import AsyncSelect from 'react-select/async'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { useRequest } from '../hooks/UseRequest'
import { detailSize, handleToolTipMouseEnter } from '../helpers/layout'
import { reactMultiSelectClassNames, reactSelectClassNames } from '../helpers/react-select-styles'
import { MODULE_FIELD_TYPES, OVERRIDE_FIELDS } from '../constants'
import { DEPEND_FIELDS } from "../constants/dependFields";
import { EMAIL_VALIDATION_PATTERN, URL_VALIDATION_PATTERN, handleFieldError } from '../helpers/fieldValidation'

function createField(field, value, fieldType, selectOptions, register, errors, control, row, sourceModule, handleStateFields, stateFields, additionalOptions) {
  if (!field.is_editable && field.is_view_only) {
    return '-'
  }
  const validationRules = {
    required: field.is_required,
    maxLength: field.max_length
  }

  let type = ''
  let validationPattern = {}
  let response = null
  let request = useRequest()
  let loadOptions = null
  let endpoint = ''

  // Used for Non System Dropdowns
  const parseLabel = ((option) => {
    let label = option.name;
    if (option.label) {
      label = option.label;
    }

    if (field.module_code_key === 'user' && field.column_name === 'user_role_id' && (option.is_active === false || option.is_active === 0)) {
      label += ' (Inactive)'
    }
    return label
  })
  //Control dependent field
  const dependField = DEPEND_FIELDS.find((item) => {
    return item.module_code_key === field.module_code_key && item.column_name === field.column_name;
  })
  const stateDependField = stateFields.find((item) => {
    return item.name === `${dependField?.module_code_key}_${dependField?.depend_column_name}`
  })
  const isDisabled = dependField && (!stateDependField || !stateDependField.value || (dependField?.depend_value && dependField.depend_value !== stateDependField.value))

  let filters = {
    and: []
  }
  switch (fieldType) {
    case MODULE_FIELD_TYPES.TAG_CLOUD.code_key:
      endpoint = `${process.env.REACT_APP_API_DOMAIN}/tag`

      if (field.tag_type_list) {
        endpoint += `?filters={"and":[{"column":"tag_type_dropdown_option_id","value":[${field.tag_type_list}],"operator":"in"}]}`
      }
      if (dependField?.filter && stateDependField && stateDependField?.value) {
        endpoint += `?filters={"and":[{"column":"${dependField.filter}","value":"${stateDependField.value}","operator":"="}]}`
      }
      request.setEndpoint(endpoint)
      loadOptions = async (inputValue) => {
        if (!response) {
          response = await request.get().then((response) => response.data.data);
        }
        if (inputValue) {
          return response.filter(
            (item) => item.name.toLowerCase().includes(inputValue.toLowerCase())
          );
        }
        return response;
      };
      return (
        <div>
          <Controller
            name={field.column_name}
            control={control}
            rules={{ ...validationRules }}
            defaultValue={value && value?.map((item) => item.id)}
            render={({ field: { onChange } }) => (
              <AsyncSelect
                isMulti
                field={field}
                cacheOptions
                isClearable={!field.is_required}
                defaultOptions
                loadOptions={loadOptions}
                defaultValue={value}
                closeMenuOnSelect={false}
                getOptionLabel={(e) => parseLabel(e)}
                getOptionValue={(e) => parseLabel(e)}
                isDisabled={isDisabled}
                classNames={reactMultiSelectClassNames(errors, field.column_name)}
                onChange={(val) => {
                  const ids = val.map((item) => item.id)
                  onChange(ids || [])
                }}
              />
            )}
          />
        </div>
      )

    case MODULE_FIELD_TYPES.DROPDOWN_SYSTEM.code_key:
      if (field.module_code_key === 'portfolio_state' && field.column_name === 'state_dropdown_option_id' && (!!sourceModule?.id)) {
        loadOptions = async () => {
          if (response) {
            return response
          }

          const portfolioId = sourceModule?.id
          if (portfolioId) {
            let endpoint = `${process.env.REACT_APP_API_DOMAIN}/portfolio_state`
            endpoint += `?filters={"and":[{"column":"portfolio_id","value":[${portfolioId}],"operator":"in"}]}`
            request.setEndpoint(endpoint)
            const responseAxios = await request.get()
            const portfolioStates = responseAxios.data.data;
            const currentStates = portfolioStates.map((ps) => ps.state_dropdown_option_id);
            if (Array.isArray(currentStates) && currentStates.length > 0) {
              response = selectOptions.dropdownOptions.filter((ddo) => !currentStates.includes(ddo.id))
            }
            return response
          }
        }

        return (
          <div>
            <Controller
              name={field.column_name}
              control={control}
              rules={{ ...validationRules }}
              defaultValue={(sourceModule && field.column_name === sourceModule?.column_name) ? sourceModule?.id : selectOptions.defaultValue?.id}
              render={({ field: { onChange } }) => (
                <AsyncSelect
                  field={field}
                  cacheOptions
                  isClearable={!field.is_required}
                  isSearchable={false}
                  defaultOptions
                  loadOptions={loadOptions}
                  defaultValue={(sourceModule && field.column_name === sourceModule?.column_name) ? {
                    name: sourceModule?.name,
                    id: sourceModule?.id,
                  } : selectOptions.defaultValue?.id && selectOptions.defaultValue}
                  getOptionLabel={(e) => parseLabel(e)}
                  getOptionValue={(e) => parseLabel(e)}
                  classNames={reactSelectClassNames(errors, field.column_name)}
                  onChange={(val) => {
                    onChange(val?.id || null)
                    handleStateFields(field.column_name, val?.id)
                  }}
                />
              )}
            />
          </div>
        )
      }
      return (
        <div>
          <Controller
            name={field.column_name}
            control={control}
            rules={{ ...validationRules }}
            defaultValue={
              selectOptions.dropdownOptions?.find(
                (option) => option.id === value,
              )?.id
            }
            render={({ field: { onChange } }) => (
              <Select
                field={field}
                options={selectOptions.dropdownOptions}
                isClearable={!field.is_required}
                defaultValue={selectOptions.dropdownOptions?.find(
                  (option) => option.id === value,
                )}
                getOptionLabel={(e) => e.name}
                getOptionValue={(e) => e.name}
                classNames={reactSelectClassNames(errors, field.column_name)}
                onChange={(val) => {
                  onChange(val?.id || null)
                  handleStateFields(field.column_name, val?.id)
                }}
              />
            )}
          />
        </div>
      )

    case MODULE_FIELD_TYPES.DROPDOWN.code_key:
      endpoint = `${process.env.REACT_APP_API_DOMAIN}/${field.dropdown_relation}`
      filters.and = []
      if (field.dropdown_filter_column && field.dropdown_filter_value) {
        // Templated `{{...}}` dropdown_filter_value was never wired up: the old code parsed the
        // placeholder then overwrote it with `row[value]` (undefined at this call site), so a templated
        // filter sent `undefined`. A production check found no module_field actually uses a `{{...}}`
        // dropdown_filter_value, so the value is used verbatim. Don't turn this into real interpolation
        // without fixing each caller's `row` prop — it is the moduleFields ARRAY at 7 of 8 call sites.
        const filterValue = field.dropdown_filter_value
        filters.and.push(
          {
            column: field.dropdown_filter_column,
            value: filterValue,
            operator: '='
          }
        )
        // endpoint += `?filters={"and":[{"column":"${field.dropdown_filter_column}","value":"${filterValue}","operator":"="}]}`
      }
      if (dependField?.filter && stateDependField && stateDependField?.value) {
        filters.and.push(
          {
            column: dependField.filter,
            value: stateDependField.value,
            operator: '='
          }
        )
        // endpoint += `?filters={"and":[{"column":"${dependField.filter}","value":"${stateDependField.value}","operator":"="}]}`
      }

      request.setEndpoint(endpoint + '?filters=' + JSON.stringify(filters))
      loadOptions = async (inputValue) => {
        if (response) {
          return response
        }

        response = request.get().then((response) => response.data.data)
        return response
      }

      return (
        <div>
          <Controller
            name={field.column_name}
            control={control}
            rules={{ ...validationRules }}
            defaultValue={(sourceModule && field.column_name === sourceModule?.column_name) ? sourceModule?.id : selectOptions.defaultValue?.id}
            render={({ field: { onChange } }) => (
              <AsyncSelect
                field={field}
                key={stateDependField?.value}
                cacheOptions
                isClearable={!field.is_required}
                isSearchable={false}
                defaultOptions
                loadOptions={loadOptions}
                defaultValue={(sourceModule && field.column_name === sourceModule?.column_name) ? { name: sourceModule?.name, id: sourceModule?.id } : selectOptions.defaultValue?.id && selectOptions.defaultValue}
                getOptionLabel={(e) => parseLabel(e)}
                getOptionValue={(e) => parseLabel(e)}
                isDisabled={isDisabled}
                classNames={reactSelectClassNames(errors, field.column_name)}
                onChange={(val) => {
                  onChange(val?.id || null)
                  handleStateFields(field.column_name, val?.id)
                }}
              />
            )}
          />
        </div>
      )

    case MODULE_FIELD_TYPES.DROPDOWN_SEARCHABLE.code_key:
      let typingTimeout = null

      loadOptions = async (inputValue) => {
        return new Promise((resolve) => {
          if (typingTimeout) clearTimeout(typingTimeout)
          typingTimeout = setTimeout(() => {
            let filterQuery = {
              and: [
                { column: 'label', value: inputValue, operator: 'like' },
              ],
            }

            if (field.module_code_key === 'payment' && field.column_name === 'customer_debit_card_id') {
              filterQuery = {
                or: [
                  { column: 'label', value: inputValue, operator: 'like' },
                  { column: 'id', value: inputValue, operator: 'like' }
                ],
              }
            }

            if (field.dropdown_filter_column && field.dropdown_filter_value) {
              // See the DROPDOWN case above: templated `{{...}}` dropdown_filter_value was never wired
              // up (no module_field actually uses one), so the value is used verbatim.
              const filterValue = field.dropdown_filter_value

              filterQuery['and'].push({ column: field.dropdown_filter_column, value: filterValue, operator: '=' })
            }

            if (dependField?.filter && stateDependField && stateDependField?.value) {
              filterQuery['and'].push({ column: dependField.filter, value: stateDependField.value, operator: '=' })
            }

            if ((field.module_code_key === 'promotion_code' && field.column_name === 'promotion_id') ||
              (field.module_code_key === 'campaign' && field.column_name === 'template_id')) {
              filterQuery['and'].push({ column: 'is_active', value: '1', operator: '=' })
            }

            request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/${field.dropdown_relation}?filters=${JSON.stringify(filterQuery)}`)
            response = request.get().then((response) => response.data.data)

            resolve(response)
          }, 1000)
        })
      }

      return (
        <div>
          <Controller
            name={field.column_name}
            control={control}
            rules={{ ...validationRules }}
            defaultValue={(sourceModule && field.column_name === sourceModule?.column_name) ? sourceModule?.id : selectOptions.defaultValue?.id}
            render={({ field: { onChange } }) => (
              <AsyncSelect
                field={field}
                cacheOptions
                isClearable={!field.is_required}
                isSearchable
                isDisabled={isDisabled}
                defaultOptions={false}
                loadOptions={loadOptions}
                defaultValue={(sourceModule && field.column_name === sourceModule?.column_name) ? { name: sourceModule?.name, id: sourceModule?.id } : selectOptions.defaultValue?.id && selectOptions.defaultValue}
                getOptionLabel={(e) => parseLabel(e)}
                getOptionValue={(e) => parseLabel(e)}
                classNames={reactSelectClassNames(errors, field.column_name)}
                noOptionsMessage={({ inputValue }) => (!inputValue ? "Start typing to search..." : "No results found")}
                onChange={(val) => {
                  onChange(val?.id || null)
                  handleStateFields(field.column_name, val?.id)
                }}
                menuPlacement="auto"
              />
            )}
          />
        </div>
      )
    // Froala Editing is handled in a modal
    case MODULE_FIELD_TYPES.HTML.code_key:
      return (
        <>
          <textarea name={field.column_name} defaultValue={value} {...register(field.column_name)}></textarea>
          -
        </>
      )

    case MODULE_FIELD_TYPES.TEXT_AREA.code_key:
      return (
        <p>
          <textarea
            name={field.column_name}
            maxLength={field.max_length}
            className="textarea"
            defaultValue={value}
            {...register(field.column_name, { ...validationRules })}
            aria-invalid={errors[field.column_name] ? 'true' : 'false'}
          />
        </p>
      )

    case MODULE_FIELD_TYPES.EMAIL.code_key:
      validationRules['pattern'] = EMAIL_VALIDATION_PATTERN
      break

    case MODULE_FIELD_TYPES.EMAIL_WITH_NAME.code_key:
      validationPattern = {
        value: /^([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})|([A-Za-z\s]+<([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,})>)$/i,
        message: 'Invalid email address',
      }
      validationRules['pattern'] = validationPattern
      break

    case MODULE_FIELD_TYPES.URL.code_key:
      validationRules['pattern'] = URL_VALIDATION_PATTERN
      break

    case MODULE_FIELD_TYPES.CURRENCY.code_key:
    case MODULE_FIELD_TYPES.PERCENT.code_key:
    case MODULE_FIELD_TYPES.TEXT.code_key:
      type = 'text'
      break

    case MODULE_FIELD_TYPES.INTEGER.code_key:
      type = 'number'
      break

    case MODULE_FIELD_TYPES.BOOLEAN.code_key:
      type = 'checkbox'
      break

    // TODO: Implement a datetime picker
    case MODULE_FIELD_TYPES.DATE.code_key:
      type = 'date'
      break

    case MODULE_FIELD_TYPES.DATETIME.code_key:
      type = 'datetime-local'
      break

    case MODULE_FIELD_TYPES.TIME.code_key:
      type = 'time'
      break

    case MODULE_FIELD_TYPES.ENCRYPTED.code_key:
      type = 'text'
      const last_four = `${field.column_name}_last_four`
      const max_length = validationRules.maxLength ? validationRules.maxLength : 10

      if (row[field.column_name]) {
        if (row[last_four]) {
          value = '#'.repeat(max_length - 4) + row[last_four]
        } else {
          value = '#'.repeat(max_length)
        }
      }
      break
  }

  let step = null
  if (type === 'time' || type === 'datetime-local') {
    step = '1'
  }

  const defaultInputValue = type === 'checkbox' ? '' : value

  return (
    <p>
      <input
        name={field.column_name}
        type={type}
        className={`${type === 'checkbox' ? 'checkbox active-blue' : 'input'
          } is-small`}
        defaultValue={(sourceModule && field.column_name == "module_code_key") ? sourceModule?.module_code_key : defaultInputValue}
        defaultChecked={value}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...register(field.column_name, { ...validationRules })}
        aria-invalid={errors[field.column_name] ? 'true' : 'false'}
        step={step}
        disabled={isDisabled}
        min={additionalOptions?.min ?? null}
      />
      {type === 'hidden' && value}
    </p>
  )
}

/**
 * Build each individual field based on type
 * @param props
 */
export default function FormFieldBuilder(props) {
  const { field, data, selectOptions, register, errors, control, row, sourceModule, fieldNotice, handleStateFields, stateFields, excludedFieldsFromOverride = [], additionalOptions = {} } = props

  let value = data || ''

  // The first clause guards the second: `field.column_name in OVERRIDE_FIELDS[module_code_key]`
  // would throw if the module key were absent, so the `&&` order must not change.
  if (field.module_code_key in OVERRIDE_FIELDS && (field.column_name in OVERRIDE_FIELDS[field.module_code_key]) && excludedFieldsFromOverride.indexOf(field.column_name) < 0) {
    value = row['original_' + field.column_name] ?? ''
  }

  const fieldType = selectOptions.fieldType
  return (
    <div className={`${detailSize(field.detail_size)} column py-2`}>
      <p className="has-text-grey is-small is-size-8">
        <span className="mr-1">{field.label_name}</span>
        <span className={field.is_required ? 'has-text-danger' : 'is-hidden'}>
          *
        </span>
        <span
          className={`${field.helper_text ? 'lox-no-border' : 'is-hidden'
            } lox-tooltip-moveable ml-1 has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary`}
          data-tooltip={field.helper_text}
          onMouseEnter={(toolTip) => handleToolTipMouseEnter(toolTip, 'form.lox-form')}
        >
          <FontAwesomeIcon icon={faQuestionCircle} className="has-text-link" />
        </span>
      </p>
      {createField(field, value, fieldType, selectOptions, register, errors, control, row, sourceModule, handleStateFields, stateFields, additionalOptions)}
      {fieldNotice}
      <p
        className={
          `${errors[field.column_name] ? 'has-text-danger is-size-7' : 'is-hidden'} lox-capitalize-first-letter`
        }
      >
        {handleFieldError(field, errors[field.column_name])}
      </p>
    </div>
  )
}
